import { defineMessages } from 'react-intl';

export default defineMessages({
  invoice: {
    id: 'Orders.OrderSummary.invoice',
    defaultMessage: 'View AuroraPay Invoice'
  },
  creditInvoice: {
    id: 'Orders.OrderSummary.creditInvoice',
    defaultMessage: 'View AuroraPay Credit Invoice'
  }
});
